exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-table[data-v-5df4b070]{width:100%;border-collapse:separate;border-spacing:0 12px}.log-row[data-v-5df4b070]{background:#fafafa;border-radius:6px;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05);box-shadow:0 1px 2px rgba(0,0,0,.05);-webkit-transition:background .2s;transition:background .2s}.log-row[data-v-5df4b070]:hover{background:#f0f8ff}td[data-v-5df4b070],th[data-v-5df4b070]{padding:6px 12px!important;font-size:14px}.guncel-alan[data-v-5df4b070],th[data-v-5df4b070]{font-weight:700}", ""]);

// exports
